import { Box } from '@codeparva/ui-components-library';
import React from 'react';
import { UserFlowTypes } from '..';
import { SectionCardTitle } from '../../../components/textVariations';
import { PassWordResetForm } from './passwordResetForm';

export const PasswordReset = ({
  resetPassword,
}: UserFlowTypes.TPasswordReset) => {
  return (
    <div className="ParentContainer">
      <div className="childPasswordContainer">
        <div className="titleContainer">
          <SectionCardTitle>Password Reset</SectionCardTitle>
        </div>
        <Box className="boxPasswordPadding">
          <PassWordResetForm resetPassword={resetPassword} />
        </Box>
      </div>
    </div>
  );
};
